export enum LoadingSpinnerSize {
  Small = 'small',
  Default = 'default',
  Medium = 'medium',
  Large = 'large'
}
